import React, { useState, useEffect } from 'react';
import TransferOfClaimModalSC from './transfer-of-claim-modal.styled';
import { HeadingTwo, HeadingFour, SmallText, BodyText } from '../../typography';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import Button from '../../ui/button';
import Checkbox from '../../ui/checkbox/checkbox';
import WishmakerModal from '../../ui/modal/modal';
import SureModal from './sure-modal';
import DocumentsVerification from '../../ui/documents-verification';
import numeral from 'numeral';
import Moment from 'react-moment';

const TransferOfClaimModal = ({ activeStep, investmentDetail, documents, onSubmit }) => {
  const [vop, setVop] = useState(false);
  const [isDefinite, setIsDefinite] = useState(false);
  const [areAllRead, setAllRead] = useState(false);

  const [isSureModalOpened, setIsSureModalOpened] = useState(false);

  const installmentsInArrears =
    investmentDetail.status.dueInstallmentCount - investmentDetail.status.paidInstallmentCount;

  useEffect(() => {
    setAllRead(false);
  }, [documents]);

  const onSureModalSubmit = (agreed) => {
    onSubmit({ type: 'transfer', agreed });
    setIsSureModalOpened(false);
  };

  return (
    <>
      <TransferOfClaimModalSC>
        <div className="top-text-wrap">
          <HeadingTwo className="bold">
            <FormattedMessage
              id="investor_loan_detail_transfer_of_claim_modal_headline"
              defaultMessage={dlt['investor_loan_detail_transfer_of_claim_modal_headline']}
            />
          </HeadingTwo>
          <BodyText>
            <FormattedHTMLMessage
              id="investor_loan_detail_transfer_of_claim_modal_headline_text"
              defaultMessage={dlt['investor_loan_detail_transfer_of_claim_modal_headline_text']}
            />
          </BodyText>
        </div>
        <div className={`loan-summary-wrap`}>
          <div className="loan-summary-wrap--top">
            <HeadingFour className="bold">{investmentDetail.debtor.wmNumber}</HeadingFour>

            <SmallText className="smaller bolder">
              <FormattedMessage
                id="investor_loan_detail_transfer_of_claim_modal_text"
                defaultMessage={dlt['investor_loan_detail_transfer_of_claim_modal_text']}
              />
            </SmallText>
          </div>
          <div className="divider"></div>
          <div className="loan-summary-wrap--bottom">
            <div className="loan-summary-wrap--bottom__row">
              <SmallText className="black-transparent">
                <FormattedMessage
                  id="investor_loan_detail_transfer_of_claim_modal_created_date"
                  defaultMessage={dlt['investor_loan_detail_transfer_of_claim_modal_created_date']}
                />
              </SmallText>
              <BodyText className="bolder">
                <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
                  {investmentDetail.loanDueAt}
                </Moment>
              </BodyText>
            </div>
            <div className="loan-summary-wrap--bottom__row">
              <SmallText className="black-transparent">
                <FormattedMessage
                  id="investor_loan_detail_transfer_of_claim_modal_amount"
                  defaultMessage={dlt['investor_loan_detail_transfer_of_claim_modal_amount']}
                />
              </SmallText>
              <BodyText className="bolder">
                {numeral(Number(investmentDetail.investor.totalTillEnd[9])).format('0,00.00')} €
              </BodyText>
            </div>
            <div className="loan-summary-wrap--bottom__row">
              <SmallText className="black-transparent">
                <FormattedMessage
                  id="investor_loan_detail_transfer_of_claim_modal_paid_installments"
                  defaultMessage={
                    dlt['investor_loan_detail_transfer_of_claim_modal_paid_installments']
                  }
                />
              </SmallText>
              <BodyText className="bolder">
                {`${investmentDetail.status.paidInstallmentCount} / ${investmentDetail.installmentCount}`}
              </BodyText>
            </div>
            <div className="loan-summary-wrap--bottom__row">
              <SmallText className="black-transparent">
                <FormattedMessage
                  id="investor_loan_detail_transfer_of_claim_modal_last_payment_date"
                  defaultMessage={
                    dlt['investor_loan_detail_transfer_of_claim_modal_last_payment_date']
                  }
                />
              </SmallText>
              <BodyText className="bolder">
                <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
                  {investmentDetail.status.lastPaymentDate}
                </Moment>
              </BodyText>
            </div>

            <div className="loan-summary-wrap--bottom__row">
              <SmallText className="black-transparent">
                <FormattedMessage
                  id="investor_loan_detail_transfer_of_claim_modal_status"
                  defaultMessage={dlt['investor_loan_detail_transfer_of_claim_modal_status']}
                />
              </SmallText>
              <BodyText className="bolder">
                <FormattedMessage
                  id="investor_loan_detail_transfer_of_claim_modal_status_in_arrears"
                  defaultMessage={
                    dlt['investor_loan_detail_transfer_of_claim_modal_status_in_arrears']
                  }
                />
                &nbsp;
                <FormattedMessage
                  id="investor_loan_detail_transfer_of_claim_modal_status_days"
                  defaultMessage={dlt['investor_loan_detail_transfer_of_claim_modal_status_days']}
                  values={{ count: investmentDetail.status.daysInArrears }}
                />
                &nbsp;
                <FormattedMessage
                  id="investor_loan_detail_transfer_of_claim_modal_status_installments"
                  defaultMessage={
                    dlt['investor_loan_detail_transfer_of_claim_modal_status_installments']
                  }
                  values={{ count: installmentsInArrears }}
                />
              </BodyText>
            </div>
          </div>
        </div>

        {activeStep === 1 ? (
          <>
            <div className="checkbox-wrap">
              <Checkbox
                name="vop"
                hasError={false}
                ErrorWrapSC={vop}
                checked={vop}
                onChange={() => setVop(!vop)}
                withInsideContent
                bold={false}
              >
                <span onClick={() => setVop(!vop)}>
                  <FormattedHTMLMessage
                    id="investor_loan_detail_transfer_of_claim_modal_vop_label"
                    defaultMessage={dlt['investor_loan_detail_transfer_of_claim_modal_vop_label']}
                    values={{
                      vopLink: `${process.env.REACT_APP_WISHMAKER_LANDING_URI}/static/pdf/vseobecne_obchodne_podmienky.pdf`,
                    }}
                  />
                </span>
              </Checkbox>
            </div>
            <div className="checkbox-wrap">
              <Checkbox
                name="vop"
                hasError={false}
                value={isDefinite}
                checked={isDefinite}
                onChange={() => setIsDefinite(!isDefinite)}
                withInsideContent
                bold={false}
              >
                <span onClick={() => setIsDefinite(!isDefinite)}>
                  <FormattedHTMLMessage
                    id="investor_loan_detail_transfer_of_claim_modal_request_is_definite_label"
                    defaultMessage={
                      dlt['investor_loan_detail_transfer_of_claim_modal_request_is_definite_label']
                    }
                  />
                </span>
              </Checkbox>
            </div>
          </>
        ) : [2, 3].includes(activeStep) ? (
          <>
            <DocumentsVerification
              documents={documents}
              setDocumentsToAllRead={(status) => setAllRead(status)}
            />
            <SmallText className="hint black-transparent">
              <FormattedMessage
                id="global_all_docs_hint"
                defaultMessage={dlt['global_all_docs_hint']}
              />
            </SmallText>
          </>
        ) : null}

        <div className="submit-wrap">
          {[1, 2].includes(activeStep) ? (
            <Button
              type="PRIMARY"
              size="BIG"
              disabled={!vop || !isDefinite || ([2, 3].includes(activeStep) && !areAllRead)}
              onClick={() => onSubmit({ type: 'transfer' })}
            >
              {activeStep === 1 ? (
                <FormattedMessage
                  id="investor_loan_detail_transfer_of_claim_modal_button_start_process"
                  defaultMessage={
                    dlt['investor_loan_detail_transfer_of_claim_modal_button_start_process']
                  }
                />
              ) : activeStep === 2 ? (
                <FormattedMessage id="global_continue" defaultMessage={dlt['global_continue']} />
              ) : null}
            </Button>
          ) : activeStep === 3 ? (
            <div className="two-buttons">
              <Button
                type="OUTLINED"
                className="secondary"
                disabled={!areAllRead}
                onClick={() => setIsSureModalOpened(true)}
              >
                <FormattedMessage
                  id="investor_loan_detail_transfer_of_claim_modal_button_do_not_sign_and_finish_process"
                  defaultMessage={
                    dlt[
                      'investor_loan_detail_transfer_of_claim_modal_button_do_not_sign_and_finish_process'
                    ]
                  }
                />
              </Button>
              <Button
                type="PRIMARY"
                disabled={!areAllRead}
                onClick={() => onSubmit({ type: 'transfer', agreed: true })}
              >
                <FormattedMessage
                  id="investor_loan_detail_transfer_of_claim_modal_button_sign_and_finish_process"
                  defaultMessage={
                    dlt[
                      'investor_loan_detail_transfer_of_claim_modal_button_sign_and_finish_process'
                    ]
                  }
                />
              </Button>
            </div>
          ) : null}
        </div>
      </TransferOfClaimModalSC>
      <WishmakerModal
        className="special"
        isOpened={isSureModalOpened}
        onClose={() => setIsSureModalOpened(false)}
        withCross
      >
        <SureModal onSubmit={(agreed) => onSureModalSubmit(agreed)} />
      </WishmakerModal>
    </>
  );
};

export default TransferOfClaimModal;
